import { DateTime } from 'luxon';

export const getDateTime = (timestampSec) => {
  return DateTime.fromMillis(timestampSec * 1000).toLocaleString(
    DateTime.DATETIME_SHORT
  );
};
